import { Pipe } from '@angular/core';

@Pipe({
  name: 'reverse'
})
export class ReversePipe {
  transform(value) {
    if (value) {
      return value.slice().reverse();
    } else {
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pipes/reverse.pipe.ts